import styled from "styled-components";

export const Container = styled.div`
  .app-input-text {
    position: relative;
    .time-icon {
      position: absolute;
      right: 0;
      top: 8px;
    }
    input {
      font-family: "latomedium" !important;
      border-radius: 4px;
      border: none;
      padding: 9px 30px 9px 0;
      font-size: 16px;
      line-height: 1;
      outline: none;
      box-shadow: none;
      border-bottom: 1px solid #e0e0e0;
      border-radius: 0;
      -webkit-transition: 200ms cubic-bezier(0, 0, 0.2, 1) 0ms;
      transition: 200ms cubic-bezier(0, 0, 0.2, 1) 0ms;
      width: 100% !important;
    }
  }
`;
